<template>
    <SvgIcon :symbol-data="symbolData"/>
</template>
<script lang="ts">
import {defineComponent} from 'vue';
import symbolData from './../../../assets/icons/stairs.svg';
import SvgIcon from './SvgIcon.vue';

export default defineComponent({
    components: {SvgIcon},
    setup() {
        return {symbolData};
    },
});
</script>
